import navigation from "@/lang/hi/navigation";
import generics from "@/lang/hi/generics";
import questions from "@/lang/hi/questions";
import a11y from "@/lang/hi/a11y";
import velt from "@/lang/hi/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
